import { Link } from "react-router-dom";
import { Shield, Mail, Heart, Clock, HeartHandshake } from "lucide-react";

export default function Footer() {
  return (
    <footer className="py-16 px-6 border-t border-border/60 bg-secondary/10 relative overflow-hidden">
      {/* Soft background glow */}
      <div className="absolute top-0 right-1/4 w-96 h-96 bg-primary/5 rounded-full filter blur-3xl pointer-events-none"></div>

      <div className="max-w-6xl mx-auto relative z-10">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-10 mb-12">
          {/* Brand and Description */}
          <div className="md:col-span-2 space-y-4">
            <div className="flex items-center gap-2.5">
              <div className="w-9 h-9 flex items-center justify-center rounded-xl bg-primary/10">
                <img src="/logo.svg" alt="Nutri Saathi Logo" className="w-7 h-7 object-contain" />
              </div>
              <span className="font-bold text-xl text-foreground font-serif">Nutri Saathi</span>
            </div>
            <p className="text-sm text-muted-foreground leading-relaxed max-w-sm">
              Your AI-powered wellness partner for Indian diets and healthy lifestyle choices. Personalized meal plans and friendly check-in calls to keep you accountable.
            </p>
            <div className="flex items-center gap-2 pt-2 text-xs text-muted-foreground">
              <Heart className="w-3.5 h-3.5 text-accent animate-pulse" />
              <span>Made with love in India</span>
            </div>
          </div>

          {/* Quick Links */}
          <div className="space-y-4">
            <h4 className="font-semibold text-foreground text-sm tracking-wider uppercase">Legal & Trust</h4>
            <ul className="space-y-3 text-sm">
              <li>
                <Link to="/terms" className="text-muted-foreground hover:text-primary transition-colors">
                  Terms & Conditions
                </Link>
              </li>
              <li>
                <Link to="/privacy" className="text-muted-foreground hover:text-primary transition-colors">
                  Privacy Policy
                </Link>
              </li>
              <li>
                <Link to="/disclaimer" className="text-muted-foreground hover:text-primary transition-colors">
                  Medical Disclaimer
                </Link>
              </li>
            </ul>
          </div>

          {/* Support and Security */}
          <div className="space-y-4">
            <h4 className="font-semibold text-foreground text-sm tracking-wider uppercase">Support & Safety</h4>
            <div className="space-y-3 text-sm">
              <a
                href="mailto:raghav@nutrisaathi.life?subject=NutriSaathi Support Request"
                className="flex items-center gap-2 text-muted-foreground hover:text-primary transition-colors"
              >
                <Mail className="w-4 h-4" />
                <span>raghav@nutrisaathi.life</span>
              </a>
              <div className="flex items-center gap-2 text-xs text-muted-foreground bg-white/40 dark:bg-black/20 p-2.5 rounded-xl border border-border/40 max-w-xs">
                <Shield className="w-4 h-4 text-primary shrink-0" />
                <span>Secure Payments via Razorpay</span>
              </div>
              <div className="flex items-center gap-2 text-xs text-muted-foreground bg-white/40 dark:bg-black/20 p-2.5 rounded-xl border border-border/40 max-w-xs">
                <HeartHandshake className="w-4 h-4 text-accent shrink-0" />
                <span>General Wellness Advisor</span>
              </div>
            </div>
          </div>
        </div>

        {/* Medical disclaimer note & copyright */}
        <div className="pt-8 border-t border-border/40 flex flex-col md:flex-row items-center justify-between gap-6">
          <p className="text-xs text-muted-foreground max-w-2xl leading-normal text-center md:text-left">
            <strong>Disclaimer:</strong> Nutri Saathi is an AI wellness coach designed to support healthy habits and Indian dietary planning. Our services do not constitute professional medical advice, diagnosis, or clinical treatment plans. Always consult with a registered physician or healthcare professional before making major dietary changes, especially if managing a chronic medical condition.
          </p>
          <div className="flex items-center gap-4 shrink-0">
            <Clock className="w-4 h-4 text-muted-foreground" />
            <span className="text-xs text-muted-foreground">
              © {new Date().getFullYear()} Nutri Saathi. All rights reserved.
            </span>
          </div>
        </div>
      </div>
    </footer>
  );
}
